var _excluded = ["children", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import classNamesMaker from "classnames";
import { DATA_SPACER } from "#library/constants/enums";
import { Icon } from "#library/components/Icon/Icon";
import IconBackArrow from "#library/assets/icons/jds_backArrow.svg";
import { Link } from "./Link";
import { linkTypes } from "./types";
import styles from "./backLink.module.css";
export var BackLink = function BackLink(props) {
  var children = props.children,
    className = props.className,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: classNamesMaker(styles["jds-BackLink"], className)
  }, restProps), /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: "#".concat(IconBackArrow.id),
    dataSpacer: DATA_SPACER.RIGHT_150
  }), children);
};
BackLink.propTypes = linkTypes;